<template>
    <div>
        <p class="is-size-5 has-text-centered-touch"  style="margin-bottom: 25px; margin-top: 25px;">
            <img class="country-image" :src="'static/images/country/' + label.country.toLowerCase() + '.png'">
            {{ label.brandName }}
        </p>
        <div class="columns is-multiline has-text-centered">
            <div class="column is-2" v-for="brand in getBrandsByCountry(label.country)">
                <router-link :to="'/auctions/models/' + brand.label" class="brand">{{ brand.label }}</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['label'],
        methods: {
            getBrandsByCountry(country) {
                return this.$store.getters.getBrandCarsByCountry(country)
            }
        }
    }
</script>

<style scoped>
    .country-image {
        height: 24px;
        width: 24px;
    }
    .brand, .brand:link, .brand:hover, .brand:visited, .brand:active {
        color: grey;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Brand/BrandContainer.vue